// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"365":"a6e6be9d","784":"83268c8d","915":"540857c7"}[chunkId] + ".css";
};